import React from "react";
import Slider from "react-slick"; // npm install react-slick slick-carousel
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Testimonial = () => {
  // Settings for react-slick
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: true,
    prevArrow: (
      <button className="testimonial-prev-arrow">
        <i className="fa-solid fa-angle-left" />
      </button>
    ),
    nextArrow: (
      <button className="testimonial-next-arrow">
        <i className="fa-solid fa-angle-right" />
      </button>
    ),
  };

  // Testimonial data – replace with your actual client images/names
  const testimonials = [
    {
      id: 1,
      text: "I've been a retailer with Panmitra for over a year now. The PAN card processing is lightning fast, and my customers love the instant e-PAN delivery. The commission structure is transparent, and the support team is always available on WhatsApp. Highly recommended!",
      name: "Rajesh Kumar",
      title: "Retailer, Bengaluru",
      image: "assets/img/all-images/testimonial-img5.png",
    },
    {
      id: 2,
      text: "We integrated Panmitra's BBPS and Recharge APIs into our fintech app. The documentation was clear, the sandbox environment worked flawlessly, and we went live in just 3 days. Our users now enjoy seamless bill payments and mobile recharges. Great tech team!",
      name: "Priya Sharma",
      title: "CTO, DigitalPay Solutions",
      image: "assets/img/all-images/testimonial-img6.png",
    },
    {
      id: 3,
      text: "As a Master Distributor, I manage over 500 retailers. Panmitra's dashboard gives me real-time insights into my team's performance, and the wallet system is super smooth. The motor insurance addition was a big hit – my retailers are earning extra commissions.",
      name: "Suresh Patil",
      title: "Master Distributor, Kolhapur",
      image: "assets/img/all-images/testimonial-img7.png",
    },
    {
      id: 4,
      text: "I needed a new PAN card urgently. Panmitra's online application was simple, and I received my PAN within 5 working days. The status tracking kept me informed at every step. Will definitely use their services again for my family and friends.",
      name: "Anita Desai",
      title: "Customer, Pune",
      image: "assets/img/all-images/testimonial-img8.png",
    },
    {
      id: 5,
      text: "We were looking for a white-label solution to offer PAN card services to our existing customer base. Panmitra's API integration was a breeze, and their support team helped us customize the portal. Our customers are happy, and we've seen a 30% increase in engagement.",
      name: "Vikram Singh",
      title: "CEO, FinServe India",
      image: "assets/img/all-images/testimonial-img9.png",
    },
  ];

  return (
    <>
      {/*===== TESTIMONIAL AREA STARTS =======*/}
      <div
        className="testimonial5-section-area sp1"
        style={{
          backgroundImage: "url(assets/img/bg/header-bg5.png)",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-7 m-auto">
              <div className="testimonial-header-area text-center heading10">
                <h5>
                  <img src="assets/img/icons/logo-icons5.svg" alt="" />
                  Testimonials
                </h5>
                <h2 className="text-anime-style-3">
                  What Our Partners & Customers Say About Panmitra
                </h2>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-8 m-auto">
              {/* React-Slick Slider */}
              <Slider {...settings} className="testimonial-sliders text-center">
                {testimonials.map((item) => (
                  <div key={item.id} className="single-testimonial">
                    {/* Optional: Display client image above the quote */}
                    <div className="testimonial-image mb-3">
                      <img
                        src={item.image}
                        alt={item.name}
                        style={{
                          width: "80px",
                          height: "80px",
                          borderRadius: "50%",
                          margin: "0 auto",
                        }}
                      />
                    </div>
                    <h5>“{item.text}”</h5>
                    <div className="author">
                      <a href="#!">{item.name}</a>
                      <p>{item.title}</p>
                    </div>
                  </div>
                ))}
              </Slider>
            </div>
          </div>
        </div>
      </div>
      {/*===== TESTIMONIAL AREA ENDS =======*/}
    </>
  );
};

export default Testimonial;
